module.exports = __webpack_public_path__ + "static/build-2-a2f132ba2e8dec72869d4f9eda317c7e.png";